import React from 'react'
import classnames from 'classnames'
//import selectn from 'selectn'
import { getPlayerRoles } from '../../../../lib/utils/common'
import { Team } from './index'
import { BatsmanLite, BowlerLite } from '../../../common'

/*
const ListOfInnings = ({
  innings = {}
}) => {

  let allInnings = Object.keys(innings) || []
  let maxInn = allInnings.length

  return (
    <div>
    {
    allInnings.map(function (innNum) {
      let inn = innings[innNum] || {}
      let title = inn.title || 'Innings'
      console.info('title', title)
      let buttonClasses = [ 'cricinfo__league__header--header' ]
      let spanClasses = [ 'cricinfo__caret' ]
      if (maxInn == innNum) {
        buttonClasses.push('cricinfo__accordion--active')
        spanClasses.push('cricinfo__caret--down')
      }
      else{
        spanClasses.push('cricinfo__caret--right')
      }
      return (
        <a className="cricinfo__league__header" ><h3
          id="h3_title" style={{ fontWeight:'normal' }} 
          className={classnames(buttonClasses)}>
            {title}
        </h3></a>
      )
    })
    }
    </div>
  )
}
*/


/**
 * get fall of wicket markup.
 * Function is required since text appears in text nodes and not inside any
 * wrapper nodes.
 *
 * @param  {Array}  fows strings of wickets fallen
 * @return {Object}      html markup object
 */
function getFowMarkup( fows = [] ) {
  let fowMarkup = ''
  if (fows.length > 0) {
    fowMarkup = `<span class="cricinfo__type__weight--bold">Fall of Wickets: </span>${fows.join(', ')}`
  }
  return { __html : fowMarkup }
}

/**
 * Print a inline list of players.
 * @return {React.Element} list of players
 */
const MultiplePlayers = ({
  players = [],
  remainingBatsmen = ''
}) => {

  let playerNames = ''
  players.map((p, i) => {
    let playerRole = getPlayerRoles(p.name, p.roles, i==players.length-1 ?  '' : ', ') || {}
    let s = playerRole.__html || ''
    playerNames += s
  })

  let remainingPlayers = { __html : `<span class='cricinfo__type__weight--bold'>${remainingBatsmen}:</span> ${playerNames}` }

  return (
          <tr className="cricinfo__table__tr">
            <td colSpan="2" className="cricinfo__table__td" dangerouslySetInnerHTML={remainingPlayers}></td>
          </tr>
  )
}


const Batting = ({
  batsmen = [],
  didNotBat = [],
  total = '',
  extras = '',
  remainingBatsmen = '',
  fows = []
}) => {

  return (
    <table className="cricinfo__table cricinfo__table--light">
    <thead>
        <tr className="cricinfo__table__tr">
            <th colSpan="2" className="cricinfo__table__th cricinfo__type__align--left">BATSMAN</th>
        </tr>
    </thead>
    <tbody>
          {
            batsmen.map((batsman = { stats: [] }, i) => {
              return <BatsmanLite batsman={batsman} bId={i} key = {i} showOutComms={true}/>
            })
          }
          {
          extras &&
          <tr className="cricinfo__table__tr">
              <td className="cricinfo__table__td cricinfo__type__weight--bold">Extras</td>
              <td className="cricinfo__table__td cricinfo__type__weight--bold cricinfo__type__align--right">{extras}</td>
          </tr> || null
          }
          {
          total &&
          <tr className="cricinfo__table__tr">
              <td className="cricinfo__table__td cricinfo__type__weight--bold">Total</td>
              <td className="cricinfo__table__td cricinfo__type__weight--bold cricinfo__type__align--right">{total}</td>
          </tr> || null
          }
          {
            didNotBat && didNotBat.length &&
            <MultiplePlayers players={didNotBat} remainingBatsmen={remainingBatsmen}/> || null
          }
          {
            fows && fows.length > 0 &&
            <tr className="cricinfo__table__tr">
              <td colSpan="2" className="cricinfo__table__td" dangerouslySetInnerHTML={getFowMarkup(fows)}></td>
            </tr> || ''
          }
    </tbody>
    </table>
  )
}


const Bowling = ({
  bowlers = []
}) => {
  return (
    <table className="cricinfo__table cricinfo__table--light">
    <thead>
        <tr className="cricinfo__table__tr">
            <th colSpan="2" className="cricinfo__table__th cricinfo__type__align--left">BOWLING</th>
        </tr>
    </thead>
    <tbody>
      {
        bowlers.map((bowler = { stats: [] }, i) => {
          return <BowlerLite bowler={bowler} bId={i} key={i}/>
        })
      }

    </tbody>
    </table>
  )
}


export const Inning = ({
  title = 'Innings',
  batsmen = [],
  bowlers = [],
  didNotBat = [],
  total = '',
  extras = '',
  remainingBatsmen = '',
  fows = [],
  id,
  otherTeamDetails = {},
  isWebView = false,
  inningStatus,
  headerInfo
}) => {

  let innStyles = {
    //border : '2px solid #f00' ,
    //'marginTop': '5px'
  }
  headerInfo = (inningStatus === 'forfeit') ? headerInfo : '' 

  return (
    <div>

    <a className="cricinfo__league__header" ><h3
      id="h3_title" style={{ fontWeight:'normal' }} 
      className={classnames('cricinfo__league__header--header')}>
        {title} {headerInfo}
    </h3></a>

    <div id="content_1" className="cricinfo__accordion__content" style={innStyles}>
        {/* This was there in markup. But have moved to batting/bowling.
            <table className="cricinfo__table cricinfo__table--light">
         */}


          <Batting batsmen={batsmen} didNotBat={didNotBat} total={total} extras={extras} remainingBatsmen={remainingBatsmen} fows={fows} isWebView={isWebView}/>

          {
            bowlers && bowlers.length > 0 &&
            <Bowling id={id} bowlers={bowlers} isWebView={isWebView}/> || ''
          }
          {
            otherTeamDetails && otherTeamDetails.players.length && <Team details={otherTeamDetails}/> || ''
          }

         {/* </table> */}
    </div>

    </div>
  )
}


const Innings = ({
  innings = {},
  otherTeamDetails = {},
  isWebView = false
}) => {
  //console.info('innings', innings)
  //console.info('otherTeamDetails', otherTeamDetails)
  //console.info('isWebView', isWebView)

  return (
    <div className="cricinfo__content__item">
      <div className="cricinfo__accordion">

        {/* <ListOfInnings innings={innings} /> */}

        {
          Object.keys(innings).map((inning, i) => {
            return <Inning key={i} id={i} {...innings[inning]} otherTeamDetails={otherTeamDetails} isWebView={isWebView}/>
          })
        }

      </div>
    </div>
  )
}

export default Innings



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/cricket/lite/Innings.jsx
 **/